export const None = '0';
export const PKCS = '1';
export const DES = '2';
export const PKCSDES = '3';
export const PGPDES = '4';
export const PGPDESMD5 = '5';
export const PEM = '6';
